import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import fundTransferService, {
  FundTransfer,
} from "../../services/fundTransferService";
import Frame from "../../components/controls/Frame/Frame";
import { useState } from "react";
import FormModal from "../../components/controls/FormModal";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import FormCommand from "../../components/controls/FormCommand";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
import { MenuItem } from "../../models/menu";
import {
  MdDelete,
  MdEdit,
  MdOutlineSend,
  MdSend,
  MdUndo,
} from "react-icons/md";

export interface FundTransferListingPageProps {}

export function getFundTransferContextMenu(): MenuItem<FundTransfer>[] {
  return [
    {
      name: "Edit",
      onClick: (d) => {
        alert(d.sourceNarration);
      },
      icon: <MdEdit />,
    },
    {
      name: "Delete",
      onClick: (d) => {
        alert(d.sourceAccountId);
      },
      icon: <MdDelete />,
    },
    {
      name: "Post Withdrawal",
      onClick: (d) => {
        alert("post ft");
      },
      icon: <MdOutlineSend />,
    },
    {
      name: "Reverse ft",
      onClick: (d) => {
        alert("Reverse ft");
      },
      icon: <MdUndo />,
    },
  ];
}

export const FundTransferListingPage = (
  props: FundTransferListingPageProps
) => {
  const [fundTransfer, setFundTransfer] = useState<FundTransfer>();
  const [fundTransfers, setFundTransfers] = useState<FundTransfer[]>([]);

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h4>Fund Transfer Order</h4>
            <GridView
              showAddButton={true}
              showSearchBar={true}
              keys={["name"]}
              name={"lstTransactions"}
              rowsPerPage={50}
              onAddRecord={() => setFundTransfer({})}
            >
              <GridView.Header>
                <thead>
                  <tr>
                    <td>Debit Account</td>
                    <td>Credit Account</td>
                    <td>Amount</td>
                    <td>Narration</td>
                    <td>Status</td>
                    <td></td>
                  </tr>
                </thead>
              </GridView.Header>
              <GridView.Content>
                {fundTransfers.map((d) => (
                  <tr>
                    <td>{d.sourceAccountName}</td>
                    <td>{d.destinationAccountName}</td>
                    <td>{d.amount}</td>
                    <td>{d.sourceNarration}</td>
                    <td>{d.status}</td>
                    <td>
                      <ContextMenu
                        item={d}
                        menu={getFundTransferContextMenu()}
                      />
                    </td>
                  </tr>
                ))}
              </GridView.Content>
            </GridView>
          </Frame>
        </div>
      </div>

      {fundTransfer && (
        <FormModal onClose={() => setFundTransfer(undefined)}>
          <FundTransferForm />
        </FormModal>
      )}
    </>
  );
};

export function FundTransferForm() {
  return (
    <div className="row">
      <div className="col">
        <div className="row">
          <div className="col">
            <label htmlFor="">(Debit)</label>
            <FindAccount
              text="Source Account"
              dataType="text"
              id="sourceAccount"
            />
          </div>
          <div className="col">
            <label htmlFor="">(Credit)</label>
            <FindAccount
              text="Destination Account"
              dataType="text"
              id="sourceAccount"
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="narration" className="control-label">
            Narration / Description
          </label>
          <textarea
            name="narration"
            id="narration"
            className="form-control form-control-sm"
          ></textarea>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="amount" className="control-label">
                Amount
              </label>
              <input
                type="number"
                name="amount"
                id="amount"
                min={0}
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="slipNo" className="control-label">
                SlipNo
              </label>
              <input
                type="number"
                name="slipNo"
                id="slipNo"
                min={0}
                className="form-control form-control-sm"
              />
            </div>
          </div>
        </div>

        <FormCommand />
      </div>
    </div>
  );
}
